<template>
  <nav>
    <router-link :to="{ name: 'Styles' }" class="cd-sidenav-nav-link nav-link">
      <font-awesome-icon :fixedWidth="true" icon="list-alt" />{{ $t("appSideBar.styles") }}
    </router-link>
    <router-link :to="{ name: 'systemConfiguration' }" class="cd-sidenav-nav-link nav-link">
      <font-awesome-icon :fixedWidth="true" icon="edit" />{{ $t("appSideBar.systemConfiguration") }}
    </router-link>
  </nav>
</template>
<script lang="ts">
import { defineComponent } from "vue";
// v-permission="'Seamworks.App.AdminSettings'"

export default defineComponent({
  name: "AppSidebar"
});
</script>
